import "./style.css";
import { t } from "../../services/formatters";
import { TextInput } from "../../components/TextInput";
import { useSession } from "../../hooks/useSession";

export const FormDatiUtenteRiconosciuto = ({ onClick = () => {} }) => {
  const { read } = useSession();

  return (
    <div className={`section white-box input-box-component`}>
      <h2>{t("well_send_you")}</h2>
      <p className="crea-appto-error full-form-appto-error hidden">Tutti i campi vanno compilati correttamente.</p>
      <p className={`input-box-subtitle`}>&nbsp;</p>
      <TextInput readonly={true} active={true} name="email" placeholder={t("email")} value={read("email")}></TextInput>
      <TextInput readonly={true} active={true} name="cellulare" placeholder={t("tel")} value={read("cellulare")}></TextInput>

      <br />
      <div className="text-center">
        <p className="text-sm regular text-disabled">{t("dati_non_aggiornati")}</p>

        <h6 className={`section action-text-component`}>
          <span onClick={onClick} className={`action-text clickable`}>
            {t("modifica")}
          </span>
        </h6>
      </div>
    </div>
  );
};
